export enum MaintenanceCategory {
  CORRECTIVE = 'corrective',
  PREVENTIVE = 'preventive',
}
